import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { storeHoursBulkRouter } from './routing/storeHoursBulkRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { storeHoursBulkAccessControlView } from './access-control/storeHoursBulkAccess.configuration'
import { holidaysListAccessControl } from './access-control/holidayListAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'store-hours-bulk',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'store-hours-bulk-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [storeHoursBulkRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsGeneral,
      attachToV3: NavEntryPointV3.Stores,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Update regular store hours in bulk for all your locations at once',
          labelId: 'storeHoursBulkDomain.title',
          // the name of the route the user should be brought to when clicking
          // on this navigation button
          route: 'store-hours-bulk-list',
          subRoutes: ['store-hours-bulk-edit', 'store-hours-bulk-update-history'],
          position: 5,
          positionNavV2: 3,
          positionNavV3: 2,
          // the accessControl configuration that determines if this nav item
          // should be displayed to the user
          accessControl: storeHoursBulkAccessControlView,
          inToolPermissions: [
            {
              slug: Permission.WarehouseLocationHoursModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.WarehouseLocationHoursModify,
            },
          ],
        },
        {
          type: 'item',
          llmDescription:
            'Manage holiday and special event hours for specific dates across your locations',
          labelId: 'storeHoursBulkDomain.holidays.title',
          // the name of the route the user should be brought to when clicking
          // on this navigation button
          route: 'holiday-list',
          subRoutes: ['store-hours-bulk-holidays-stores-confirmed-list'],
          position: 6,
          positionNavV2: 4,
          positionNavV3: 3,

          // the accessControl configuration that determines if this nav item
          // should be displayed to the user
          accessControl: holidaysListAccessControl,
          inToolPermissions: [
            {
              slug: Permission.WarehouseLocationHoursModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.WarehouseLocationHoursModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
